import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { TrackReference } from '@livekit/components-core';
import { selectLowerThirdsPercentage } from '../../../../redux/slices/room';
import {
  SideBySideStreamingViews,
  StreamingView,
} from '../../../../redux/streamGoApi/enums';
import { NameTag } from '../../../DynamicLayout/StreamingView';
import { ParticipantTileMinimal } from '../../../LiveKit/ParticipantTileMinimal';
import { useGetTracks } from '../../hooks';
import { useSetLiveView } from '../../hooks/useSetLiveView';
import { VideoContainer } from '../../Styled';
import { SingleTrackView } from '../SingleTrackView';
import { sideBySideConfig } from './config';
import { useGetRightWidthPercentage } from './hooks';
import {
  SideBySideViewVideoContainer,
  SideBySideViewVideoOrImageTrack,
  SideBySideViewVideoTrack,
} from './Styled';

interface ISideBySideView {
  streamingView?: StreamingView;
}

export const SideBySideView = ({ streamingView }: ISideBySideView) => {
  const lowerThirdsPercentage = useSelector(selectLowerThirdsPercentage);
  const ref = useRef<HTMLVideoElement>(null);
  const { tracks } = useGetTracks();

  const { inline, leftStream, ratio, rightStream, rightWidth } =
    sideBySideConfig[streamingView as unknown as SideBySideStreamingViews];

  const leftTrack = tracks[leftStream] as TrackReference;
  const rightTrack = tracks[rightStream] as TrackReference;

  const { rightRatio, rightW } = useGetRightWidthPercentage({
    inline,
    ratio,
    refHeight: ref.current?.clientHeight,
    refWidth: ref.current?.clientWidth,
    rightTrack,
    rightWidth,
  });

  useSetLiveView({
    component: 'sideBySideView',
    videoTracks: [rightTrack],
  });

  if (!leftTrack && !rightTrack) {
    return <></>;
  }

  if (leftTrack && !rightTrack) {
    return <SingleTrackView disableSetLive={true} streamType={leftStream} />;
  }

  if (!leftTrack && rightTrack) {
    return <SingleTrackView disableSetLive={true} streamType={rightStream} />;
  }

  return (
    <>
      <SideBySideViewVideoContainer height={`${100 - lowerThirdsPercentage}vh`}>
        <div>
          <SideBySideViewVideoTrack
            maxHeight={`${100 - lowerThirdsPercentage}vh`}
            ref={ref}
            trackRef={leftTrack}
            width={rightW ? 100 - rightW : undefined}
          />
        </div>
        <VideoContainer className="video-cover">
          <SideBySideViewVideoOrImageTrack ratio={rightRatio} width={rightW}>
            <ParticipantTileMinimal
              className="videoCam"
              trackRef={rightTrack}
            />
          </SideBySideViewVideoOrImageTrack>
          <NameTag participant={rightTrack.participant} />
        </VideoContainer>
      </SideBySideViewVideoContainer>
    </>
  );
};
